module.exports = __webpack_public_path__ + "img/gas01_play.c2edb9a3.gif";